(() => {
  if (customElements.get('collection-promo-slider')) return;

  class CollectionPromoSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-promo-track]');
      this.previous = this.querySelector('[data-promo-prev]');
      this.next = this.querySelector('[data-promo-next]');
      if (!this.track || !this.previous || !this.next) return;

      this.update = this.update.bind(this);
      this.onPrevious = () => this.move(-1);
      this.onNext = () => this.move(1);
      this.previous.addEventListener('click', this.onPrevious);
      this.next.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this);
      this.observer.observe(this.track);
      this.contentObserver = new MutationObserver(this.update);
      this.contentObserver.observe(this.track, { childList: true });
      this.update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.contentObserver?.disconnect();
      this.previous?.removeEventListener('click', this.onPrevious);
      this.next?.removeEventListener('click', this.onNext);
      this.track?.removeEventListener('scroll', this.update);
    }

    update() {
      const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
      // Measure without arrows as well, so both disappear when all links fit.
      const availableWidth = this.clientWidth;
      const scrollable = this.track.scrollWidth > availableWidth + 2;
      this.toggleAttribute('data-scrollable', scrollable);
      const position = Math.abs(this.track.scrollLeft);
      const end = this.track.scrollWidth - this.track.clientWidth;
      this.previous.disabled = !scrollable || position < 2;
      this.next.disabled = !scrollable || !overflow || position >= end - 2;
    }

    move(direction) {
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({
        left: direction * (rtl ? -1 : 1) * this.track.clientWidth * 0.8,
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    }
  }

  customElements.define('collection-promo-slider', CollectionPromoSlider);
})();
